import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { IEvent } from '@internal-models/event.model';
import { ICalendarEvent } from '@shared-models/calendar-event.model';

@Injectable({
	providedIn: 'root',
})
export class EventProvider extends Provider<IEvent> {
	protected readonly url: string = '/events';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public getOne(eventId: string): Promise<IEvent> {
		return this.process(this.api.get(`${this.url}/${eventId}`)) as Promise<IEvent>;
	}

	public getOneForDay(eventId: string, calendarEventId: string): Promise<IEvent> {
		return this.process(this.api.get(`${this.url}/${eventId}/${calendarEventId}`)) as Promise<IEvent>;
	}

	public create(event: IEvent): Promise<IEvent> {
		return this.process(this.api.post(`${this.url}`, event)) as Promise<IEvent>;
	}

	public update(
		eventId: string,
		Event: IEvent,
		CalendarEvent: ICalendarEvent,
		isRecurring: boolean
	): Promise<IEvent> {
		return this.process(
			this.api.put<any>(`${this.url}/${eventId}`, { Event, CalendarEvent, isRecurring })
		) as Promise<IEvent>;
	}

	public delete(eventId: string, CalendarEvent: ICalendarEvent, isRecurring: boolean): Promise<void> {
		return this.process(this.api.delete(`${this.url}/${eventId}`, { CalendarEvent, isRecurring }));
	}
}
